export default {
    computed:{
        $loginStatus(){
            return this.$store.state.loginStatus
        }
    },
    methods:{
        $hasMenu(menuUrl){
            return this.$store.getters['loginStatus/hasMenu'](menuUrl)
        },
        $getMenuById(menuId){
            return this.$store.getters['loginStatus/getMenuById'](menuId)
        },
        $getRoleInfo(roleName){
            return this.$store.getters['loginStatus/getRoleInfo'](roleName)
        },
        $hasLogin(){
            return this.$store.getters['loginStatus/hasLogin']()
        },
        $sendToApp(data) {
            if (typeof uni !== 'undefined' && uni.postMessage) {
                uni.postMessage({
                    data: data
                });
                console.log('已发送给APP:', data);
            } else {
                console.warn('不在uni-app环境中，无法使用uni.postMessage');
            }
        }
    }
}